<app-header></app-header>
<div class="section container-fluid pt-3 pb-4">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section pb-3">
            <div class="row p-2">
                <div class="col-sm-4 pt-2">
                    <span class="header">Blog</span>
                </div>
                <div class="col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-2 mt-sm-0">
                    <div class="input-icons">
                        <i class="fas fa-search"></i>
                        <input class="form-control form-control-lg search" [(ngModel)]="searchText"
                            placeholder="Search blog" (keyup.enter)="searchBlog()">
                    </div>
                </div>
            </div>
            <div class="horizontal-line"></div>
            <div class="row">
                <div class="col-xl-8 main-feed">
                    <div class="d-flex flex-row navigate my-4" *ngFor="let blog of blogs"
                        [routerLink]="['/blog-detail', blog.postId]">
                        <img *ngIf="!blog.image" src="../../../assets/Images/blog-not-found.png" class="blog-image"
                            alt="blog">
                        <img *ngIf="blog.image" [src]="blog.image" class="blog-image" alt="blog">
                        <div class="d-flex flex-column px-3">
                            <span class="blog-time mb-2">{{blog?.createdAt| date:'EEE dd MMM, yyyy'}}</span>
                            <div class="blog-title-section mb-2">
                                <span class="title">{{blog?.title}}</span>
                            </div>
                            <div class="blog-sub-title-section">
                                <span class="sub-title mt-2">{{blog?.body}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="no-data" *ngIf="!blogs.length && !blogLoading">
                        <img class="align-self-center" src="../../../assets/Images/NoDocuments.png" height="50"
                            width="80" alt="No Notes">
                        <span>No Blogs</span>
                    </div>
                    <div class="row my-5" *ngIf="blogLoading">
                        <div class="spinner-border loader" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button class="btn btn-theme btn-lg mt-2" *ngIf="showLoadMore"
                                (click)="loadMoreBlogs()">Load More</button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 recent-feed">
                    <div class="d-flex flex-column">
                        <span class="sub-header mt-3 mb-2" *ngIf="recentBlogs.length">Recent
                            Posts</span>
                        <div class="row my-5" *ngIf="recentBlogLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column navigate" *ngIf="recentBlogs.length">
                            <div class="d-flex flex-row my-1" *ngFor="let rblog of recentBlogs"
                                [routerLink]="['/blog-detail', rblog.postId]">
                                <img *ngIf="!rblog.image" src="../../../assets/Images/blog-not-found.png"
                                    class="blog-image" alt="blog">
                                <img *ngIf="rblog.image" [src]="rblog.image" class="blog-image" alt="blog">
                                <div class="d-flex flex-column px-3">
                                    <div class="blog-title-section mb-2">
                                        <span class="title">{{rblog?.title}}</span>
                                    </div>
                                    <div class="blog-sub-title-section">
                                        <span class="sub-title mt-2">{{rblog?.body}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="sub-header mt-3 mb-2">Tags</span>
                        <div class="row my-5" *ngIf="tagLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row flex-wrap">
                            <div class="tags" *ngFor="let tag of tags" [routerLink]="['/blog-listing']"
                                [queryParams]="{ tagId: tag.topicId}" [ngClass]="{active: tag.topicId==topicId}">
                                {{tag.name}} ({{tag.postCount}})</div>
                        </div>
                        <span class="sub-header mt-4 mb-2">Archives</span>
                        <div class="row my-5" *ngIf="monthLoading">
                            <div class="spinner-border loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row flex-wrap">
                            <div class="tags" *ngFor="let month of months" [routerLink]="['/blog-listing']"
                                [queryParams]="{ month: month.monthName}"
                                [ngClass]="{active: month.monthName==monthFilter}">
                                {{month.monthName}} ({{month.postCount}})
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>